// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  box-shadow: none;
}

.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #f3f3f3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #f3f3f3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-family: AppFontMedium;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  margin: 0 10px;
}
@media (min-width: 991px) {
  .main_row .item_row {
    margin: 0 0px 0 10px;
  }
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding: 0;
}
.main_row .order-col {
  padding-top: 23px;
}

@media (min-width: 991px) {
  .item-col {
    margin-bottom: 0px;
    padding: 0px 7px 13px;
  }
}

app-item-view {
  padding: 6px;
}

.category-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .category-row {
    justify-content: flex-start;
    padding-left: 13px;
  }
}
.category-row h2 {
  font-family: AppFont;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .category-row h2 {
    font-size: 22px;
    line-height: 33.01px;
  }
}

.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}

.footer-btn {
  border-top: 1px solid var(--accent-color);
  border-radius: 20px 20px 0 0;
}

.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}

.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}

.filers_section {
  background: var(--color-background-alt);
}
@media (max-width: 992px) {
  .filers_section {
    border-bottom: 1px solid #222222;
  }
}

.main-content {
  --padding-start: 0%;
  --padding-end: 0%;
}

.main-content::part(scroll)::-webkit-scrollbar {
  display: none;
}

.main-content::part(scroll) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.filter-btn {
  min-height: 48px;
  width: 48px;
  height: 48px;
  margin-right: 5px;
  --padding-start: 11px;
  --padding-end: 11px;
  background: #fff;
}

.category-list {
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
@media (min-width: 991px) {
  .category-list {
    flex-grow: 1;
    padding: 10px 0;
  }
  .category-list > ion-chip {
    overflow: unset;
    display: flex;
    flex-grow: 1 !important;
  }
}
.category-list::-webkit-scrollbar {
  display: none;
}
.category-list ion-chip {
  flex: 0 0 auto;
  height: 48px;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin: 0px 5px;
  --background: transparent;
  border-radius: 8px;
  border: 1px solid var(--accent-color);
  transition: 200ms linear;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.category-list ion-chip:hover {
  --background: #F2DBD9;
}
.category-list ion-chip:last-child {
  margin-right: 15px;
}
.category-list ion-chip p {
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.category-list ion-chip ion-icon,
.category-list ion-chip ion-img,
.category-list ion-chip img {
  height: 31px;
  width: 31px;
  margin-right: 5px;
}
.category-list ion-chip.selected {
  transition: 200ms linear;
  background: var(--accent-color);
}
.category-list ion-chip.selected p {
  color: white;
}
.category-list ion-chip.selected ion-icon {
  fill: var(--accent-color);
}

.more {
  min-height: 400px !important;
  width: 100%;
}
@media (max-width: 992px) {
  .more {
    min-height: 250px !important;
    width: 100%;
  }
}

.venue-info-col {
  padding: 12px 15px;
}

.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  background: #1a1410;
  border: 1px solid var(--accent-color);
  border-radius: 16px;
  max-width: 400px;
}
.venue_info_block h3 {
  font-family: AppFontMedium, sans-serif;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  text-transform: none;
  margin: 0 0 6px;
}
.venue_info_block p {
  font-family: AppFont, sans-serif;
  font-size: 13px;
  line-height: 16px;
  color: #c9c9c9;
  margin: 0;
}
.venue_info_block ion-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-left: 20px;
  cursor: pointer;
}

.filters_section {
  z-index: 99;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: white;
  min-height: 0px;
  opacity: 0;
  z-index: -1;
  transition: min-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
}
.filters_section.show-filters {
  z-index: 999;
  opacity: 1;
  min-height: 200px;
}

.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}

.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.max-height-100 {
  max-height: 100%;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 400px;
  background: #fbfbfb;
  right: -400px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.fixed-notification {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #a28b7b;
  color: var(--color-black);
  font-family: AppFontMedium;
  text-transform: uppercase;
  text-align: center;
  padding: 20px;
  min-height: 0px;
  height: 0px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.fixed-notification.show-item {
  opacity: 1;
  height: -moz-fit-content;
  height: fit-content;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
@media (max-width: 992px) {
  .fixed-notification {
    bottom: 100px;
    font-size: 14px;
  }
}

.filter-modal {
  --height: auto;
  --border-radius: 32px 32px 0 0;
  --background: #000;
}

.filter-modal::part(content) {
  height: auto;
  max-height: 70vh;
  border-radius: 32px 32px 0 0;
  overflow: hidden;
}

.filter-modal-content {
  padding: 24px;
  background: #000;
  color: #fff;
}

.filter-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2705882353);
}
.filter-header h2 {
  margin: 0;
  font-size: 48px;
  font-weight: 300;
}
.filter-header ion-button {
  --color: #a56d56;
  font-size: 20px;
  border: none;
  --padding-end: 0;
}

.filter-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.filter-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}
.filter-item ion-toggle {
  zoom: 1.2;
  --track-background: #d9d9d9;
  --track-background-checked: #a56d56;
  --handle-background: #fff;
  --handle-background-checked: #fff;
  --handle-spacing: 2px;
  --handle-width: 18px;
  --handle-height: 18px;
}

.apply-btn {
  margin-top: 40px;
}

ion-toggle::part(track),
ion-toggle.toggle-checked::part(track) {
  height: 22px;
  width: 38px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAMA;EACC,gBAAA;AALD;;AAQA;EACC,YAAA;AALD;AAWC;EACC,mBAAA;AATF;AAUE;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;AAVH;AAWG;EACC,WAAA;EACA,kBAAA;AATJ;AAWG;EACC,oCAAA;EACA,eAAA;EACA,iCAAA;AATJ;AAYG;EACC,eAAA;AAVJ;AAaG;EACC,oCAAA;EACA,WAAA;AAXJ;AAYI;EACC,YAAA;AAVL;AAeC;EACC,WAAA;EACA,WAAA;EACA,mBAAA;AAbF;AAeC;EACC,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;AAdF;AAiBC;EACC,cAAA;AAfF;ACxDE;EDsED;IAIE,oBAAA;EAdD;AACF;AAiBC;EACC,kBAAA;EACA,gBAAA;EACA,UAAA;AAfF;AAkBC;EACC,iBAAA;AAhBF;;ACrEE;EDyFF;IAEE,kBAAA;IAEA,qBAAA;EAlBA;AACF;;AAqBA;EACC,YAAA;AAlBD;;AAqBA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAlBD;ACxFE;EDqGF;IAQE,2BAAA;IACA,kBAAA;EAjBA;AACF;AAkBC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAhBF;ACtGE;EDgHD;IASE,eAAA;IACA,oBAAA;EAfD;AACF;;AAmBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAhBD;AAiBC;EACC,wCAAA;EACA,qBAAA;AAfF;AAiBC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;AAfF;AAgBE;EACC,SAAA;AAdH;;AAmBA;EACC,yCAAA;EACA,4BAAA;AAhBD;;AAmBA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAhBD;AAiBC;EACC,WAAA;AAfF;;AAmBA;EACC,YAAA;EACA,aAAA;AAhBD;AAiBC;EACC,WAAA;AAfF;;AAmBA;EACC,uCAAA;AAhBD;AC5JE;ED2KF;IAGE,gCAAA;EAdA;AACF;;AAiBA;EACC,mBAAA;EACA,iBAAA;AAdD;;AAiBA;EACC,aAAA;AAdD;;AAgBA;EACC,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AAbD;;AAgBA;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAbD;;AAeA;EACC,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;AAZD;ACvME;ED8MF;IAQE,YAAA;IACA,eAAA;EAXA;EAaA;IACC,eAAA;IACA,aAAA;IACA,uBAAA;EAXD;AACF;AAeC;EACC,aAAA;AAbF;AAgBC;EACC,cAAA;EACA,YAAA;EAEA,2BAAA;EAAA,sBAAA;EACA,eAAA;EAEA,yBAAA;EACA,kBAAA;EACA,qCAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;AAjBF;AAkBE;EACC,qBAAA;AAhBH;AAoBE;EACC,kBAAA;AAlBH;AAqBE;EACC,gBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,SAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AApBH;AAsBE;;;EAGC,YAAA;EACA,WAAA;EACA,iBAAA;AApBH;AAuBE;EACC,wBAAA;EACA,+BAAA;AArBH;AAsBG;EACC,YAAA;AApBJ;AAuBG;EACC,yBAAA;AArBJ;;AA0BA;EACC,4BAAA;EACA,WAAA;AAvBD;ACrQE;ED0RF;IAIE,4BAAA;IACA,WAAA;EArBA;AACF;;AAuBA;EACC,kBAAA;AApBD;;AAuBA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AApBD;AAsBC;EACC,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;AApBF;AAuBC;EACC,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AArBF;AAwBC;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAtBF;;AAyBA;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,iEAAA;EACA,2DAAA;EACA,6BAAA;EACA,4BAAA;AAtBD;AAuBC;EACC,YAAA;EACA,UAAA;EACA,iBAAA;AArBF;;AAwBA;EACC,aAAA;EACA,uBAAA;EACA,iBAAA;AArBD;;AAuBA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApBD;;AAuBA;EACC,gBAAA;AApBD;;AA2BA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YA3X0B;EA4X1B,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;AA5BD;AA8BC;EACE,QAAA;EAGA,oDAAA;AA5BH;AAgCG;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AA/BF;AAkCG;EACD,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAhCF;AAiCE;EACE,YAAA;EACA,WAAA;AA/BJ;;AAoCE;EACD,eAAA;EACG,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACH,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;AAjCD;AAmCC;EACC,UAAA;EACA,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;AAjCF;ACxZE;EDsaA;IAsBA,aAAA;IACA,eAAA;EAhCA;AACF;;AAqCA;EACC,cAAA;EACA,8BAAA;EACA,kBAAA;AAlCD;;AAqCA;EACC,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAlCD;;AAqCA;EACC,aAAA;EACA,gBAAA;EACA,WAAA;AAlCD;;AAqCA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,0DAAA;AAlCD;AAoCC;EACC,SAAA;EACA,eAAA;EACA,gBAAA;AAlCF;AAqCC;EACC,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAnCF;;AAuCA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AApCD;;AAuCA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,cAAA;AArCD;AAuCC;EACC,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,yBAAA;EACA,iCAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AArCF;;AAyCA;EACC,gBAAA;AAtCD;;AA0CA;;EAEC,YAAA;EACA,WAAA;AAvCD","sourcesContent":["@import '../../../theme/mixins';\n\n\n$container_padding_top: 30px;\n$order_basket_block_width: 400px;\n\nion-header {\n\tbox-shadow: none;\n}\n\n.main_row {\n\theight: 100%;\n\n\t// @include tablet {\n\t//   height: 90%;\n\t// }\n\n\t.category_col {\n\t\tbackground: #f3f3f3;\n\t\t.category_item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\talign-items: center;\n\t\t\tpadding: 10px 5px 10px 10px;\n\t\t\tmargin-top: 1.5px;\n\n\t\t\tbackground: #f3f3f3;\n\t\t\tborder-radius: 0px;\n\n\t\t\ttransition: all 0.3s;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\tborder-bottom: 1.5px solid #4f614f1a;\n\t\t\tion-img {\n\t\t\t\twidth: 60px;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t\th3 {\n\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t}\n\n\t\t\t&:first-of-type {\n\t\t\t\tmargin-top: 0px;\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tbackground: var(--ion-color-primary);\n\t\t\t\tcolor: #fff;\n\t\t\t\th3 {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.border_top_line {\n\t\twidth: 100%;\n\t\theight: 3px;\n\t\tbackground: #d9d9d9;\n\t}\n\t.category_name {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 17px;\n\t\tletter-spacing: 0em;\n\t\ttext-align: left;\n\n\t\tpadding: 30px 0px 20px 7px;\n\t}\n\n\t.item_row {\n\t\tmargin: 0 10px;\n\n\t\t@include desktop {\n\t\t\tmargin: 0 0px 0 10px;\n\t\t}\n\t}\n\n\t.catalog_col {\n\t\tposition: relative;\n\t\toverflow: hidden;\n\t\tpadding: 0;\n\t}\n\n\t.order-col {\n\t\tpadding-top: 23px;\n\t}\n}\n\n.item-col {\n\t@include desktop {\n\t\tmargin-bottom: 0px;\n\t\t// padding-inline: 13px;\n\t\tpadding: 0px 7px 13px;\n\t}\n}\n\napp-item-view {\n\tpadding: 6px;\n}\n\n.category-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding-block: 23px;\n\n\t@include desktop {\n\t\tjustify-content: flex-start;\n\t\tpadding-left: 13px;\n\t}\n\th2 {\n\t\tfont-family: AppFont;\n\t\tfont-size: 20px;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0px;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\n\t\t@include desktop {\n\t\t\tfont-size: 22px;\n\t\t\tline-height: 33.01px;\n\t\t}\n\t}\n}\n\n.search_col {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-searchbar {\n\t\t--box-shadow: 0px 0px 42px 0px #00000012;\n\t\t--border-radius: 10px;\n\t}\n\t.open_filters {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\twidth: 42px;\n\t\theight: 42px;\n\t\tborder-radius: 10px;\n\t\tbox-shadow: 0px 0px 42px 0px #00000012;\n\t\tion-icon {\n\t\t\tzoom: 1.3;\n\t\t}\n\t}\n}\n\n.footer-btn {\n\tborder-top: 1px solid var(--accent-color);\n\tborder-radius: 20px 20px 0 0;\n}\n\n.footer-btn-desktop {\n\tposition: absolute;\n\tbottom: 35px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 40%;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\twidth: 100%;\n\t}\n}\n\n.order_list_row {\n\theight: 100%;\n\tdisplay: flex;\n\tapp-order-content {\n\t\twidth: 100%;\n\t}\n}\n\n.filers_section {\n\tbackground: var(--color-background-alt);\n\t@include mobile {\n\t\tborder-bottom: 1px solid #222222;\n\t}\n}\n\n.main-content {\n\t--padding-start: 0%;\n\t--padding-end: 0%;\n}\n\n.main-content::part(scroll)::-webkit-scrollbar {\n\tdisplay: none;\n}\n.main-content::part(scroll) {\n\t-ms-overflow-style: none; /* IE and Edge */\n\tscrollbar-width: none; /* Firefox */\n}\n\n.filter-btn {\n\tmin-height: 48px;\n\twidth: 48px;\n\theight: 48px;\n\tmargin-right: 5px;\n\t--padding-start: 11px;\n\t--padding-end: 11px;\n\tbackground: #fff;\n}\n.category-list {\n\tdisplay: flex;\n\toverflow: auto;\n\tscroll-behavior: smooth;\n\t-ms-overflow-style: none;\n\tscrollbar-width: none; /* Firefox */\n\n\t@include desktop {\n\t\tflex-grow: 1;\n\t\tpadding: 10px 0;\n\t\t// border-bottom: 1px solid #272727;\n\t\t> ion-chip {\n\t\t\toverflow: unset;\n\t\t\tdisplay: flex;\n\t\t\tflex-grow: 1 !important;\n\t\t\t// padding: 12px 16px;\n\t\t}\n\t}\n\n\t&::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n\n\tion-chip {\n\t\tflex: 0 0 auto;\n\t\theight: 48px;\n\n\t\tmax-width: fit-content;\n\t\tmargin: 0px 5px;\n\n\t\t--background: transparent;\n\t\tborder-radius: 8px;\n\t\tborder: 1px solid var(--accent-color);\n\t\ttransition: 200ms linear;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\toverflow: hidden;\n\t\t&:hover {\n\t\t\t--background: #F2DBD9;\n\t\t}\n\n\n\t\t&:last-child {\n\t\t\tmargin-right: 15px;\n\t\t}\n\n\t\tp {\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 12px;\n\t\t\ttext-align: center;\n\n\t\t\tmargin: 0;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 1;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\t\tion-icon,\n\t\tion-img,\n\t\timg{\n\t\t\theight: 31px;\n\t\t\twidth: 31px;\n\t\t\tmargin-right: 5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\ttransition: 200ms linear;\n\t\t\tbackground: var(--accent-color);\n\t\t\tp {\n\t\t\t\tcolor: white;\n\t\t\t}\n\n\t\t\tion-icon {\n\t\t\t\tfill: var(--accent-color);\n\t\t\t}\n\t\t}\n\t}\n}\n.more {\n\tmin-height: 400px !important;\n\twidth: 100%;\n\t@include mobile {\n\t\tmin-height: 250px !important;\n\t\twidth: 100%;\n\t}\n}\n.venue-info-col {\n\tpadding: 12px 15px;\n}\n\n.venue_info_block {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\tpadding: 16px 18px;\n\tbackground: #1a1410;\n\tborder: 1px solid var(--accent-color);\n\tborder-radius: 16px;\n\tmax-width: 400px;\n\n\th3 {\n\t\tfont-family: AppFontMedium, sans-serif;\n\t\tfont-size: 16px;\n\t\tline-height: 20px;\n\t\tcolor: #fff;\n\t\ttext-transform: none;\n\t\tmargin: 0 0 6px;\n\t}\n\n\tp {\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-size: 13px;\n\t\tline-height: 16px;\n\t\tcolor: #c9c9c9;\n\t\tmargin: 0;\n\t}\n\n\tion-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t\tflex-shrink: 0;\n\t\tmargin-left: 20px;\n\t\tcursor: pointer;\n\t}\n}\n.filters_section {\n\tz-index: 99;\n\tposition: absolute;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\tbackground: white;\n\tmin-height: 0px;\n\topacity: 0;\n\tz-index: -1;\n\ttransition: min-height 0.3s ease-in-out, opacity 0.3s ease-in-out;\n\tbox-shadow: 0px 0px 20px 0px #4f614f26;\n\tborder-top-right-radius: 16px;\n\tborder-top-left-radius: 16px;\n\t&.show-filters {\n\t\tz-index: 999;\n\t\topacity: 1;\n\t\tmin-height: 200px;\n\t}\n}\n.filter-toggle {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 10px 0px;\n}\n.no_items {\n\twidth: 100%;\n\theight: 70vh;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.max-height-100 {\n\tmax-height: 100%;\n}\n\n\n\n\n\n.order_basket_block {\n\tposition: absolute;\n\tz-index: 20;\n\theight: 99%;\n\n\twidth: $order_basket_block_width;\n\tbackground: #fbfbfb;\n\t// box-shadow: 0px 4px 4px 0px #00000040;\n\n\tright: calc($order_basket_block_width * (-1));\n\ttop: -1px;\n\n\ttransition: right 0.3s;\n\n\t&.open {\n\t  right: 0;\n\t  -webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t  -moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t  box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n\t}\n\n\t.order_basket_header {\n\t  .close_basket_col {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: transparent;\n\t\tpadding-left: 20px;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tletter-spacing: 0em;\n\t\tcolor: var(--ion-color-black);\n\t\tbackground: #f9f9f9;\n\t  }\n\n\t  .close_basket_img_col {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: #d9d9d9;\n\t\tpadding: 0 16.5px;\n\t\theight: 55px;\n\t\twidth: 55px !important;\n\t\t.close_basket_img {\n\t\t  height: 14px;\n\t\t  width: 14px;\n\t\t}\n\t  }\n\t}\n  }\n  .fixed-notification {\n\tposition: fixed;\n    bottom: 0px;\n    left: 0px;\n    right: 0px;\n    background: #a28b7b;\n\tcolor: var(--color-black);\n\tfont-family: AppFontMedium;\n\ttext-transform: uppercase;\n\ttext-align: center;\n\tpadding: 20px;\n\tmin-height: 0px;\n\theight: 0px;\n\ttransition: opacity 0.3s ease-in-out;\n\topacity: 0;\n\n\t&.show-item {\n\t\topacity: 1;\n\t\theight: fit-content;\n\t\tmin-height: fit-content;\n\t}\n\t@include mobile {\n\t\tbottom: 100px;\n\t\tfont-size: 14px;\n\t}\n  }\n\n\n////////filter-modal\n.filter-modal {\n\t--height: auto;\n\t--border-radius: 32px 32px 0 0;\n\t--background: #000;\n}\n\n.filter-modal::part(content) {\n\theight: auto;\n\tmax-height: 70vh;\n\tborder-radius: 32px 32px 0 0;\n\toverflow: hidden;\n}\n\n.filter-modal-content {\n\tpadding: 24px;\n\tbackground: #000;\n\tcolor: #fff;\n}\n\n.filter-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 32px;\n\tborder-bottom: 1px solid #ffffff45;\n\n\th2 {\n\t\tmargin: 0;\n\t\tfont-size: 48px;\n\t\tfont-weight: 300;\n\t}\n\n\tion-button {\n\t\t--color: #a56d56;\n\t\tfont-size: 20px;\n\t\tborder: none;\n\t\t--padding-end: 0;\n\t}\n}\n\n.filter-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n}\n\n.filter-item {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\tpadding: 4px 0;\n\n\tion-toggle {\n\t\tzoom: 1.2;\n\t\t--track-background: #d9d9d9;\n\t\t--track-background-checked: #a56d56;\n\t\t--handle-background: #fff;\n\t\t--handle-background-checked: #fff;\n\t\t--handle-spacing: 2px;\n\t\t--handle-width: 18px;\n\t\t--handle-height: 18px;\n\t}\n}\n\n.apply-btn {\n\tmargin-top: 40px;\n}\n\n\nion-toggle::part(track),\nion-toggle.toggle-checked::part(track) {\n\theight: 22px;\n\twidth: 38px;\n\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
